import { createReducer, on } from '@ngrx/store';
import { titleAction, OpenTasksActions, RequestState } from './external-auth.actions';
import { WorkflowTaskType } from '@shared/components/notifications/notification';
import {
  handleFailure,
  handleRequest,
  handleSuccess,
  handleClear,
} from '@shared/ngrx-factory/factory.reducer';

export interface ExternalAuthState {
  title: string;
  openTasks: RequestState<WorkflowTaskType[]>;
}

const initialRequestState: RequestState<WorkflowTaskType[]> = {
  loading: false,
  message: null,
  response: null,
  error: null,
};

const initialState: ExternalAuthState = {
  title: '',
  openTasks: { ...initialRequestState },
};

export const externalAuthReducer = createReducer(
  initialState,

  on(titleAction, (state, { title }): ExternalAuthState => {
    return {
      ...state,
      title: title,
    };
  }),

  on(OpenTasksActions.request, (state) => handleRequest(state, 'openTasks')),
  on(OpenTasksActions.success, (state, { response }) => handleSuccess(state, 'openTasks', response)),
  on(OpenTasksActions.failure, (state, { error }) => handleFailure(state, 'openTasks', error)),
  on(OpenTasksActions.clearState, (state) => handleClear(state, 'openTasks')),
);
